import { appConfig } from "../services/configService";

const { geoserverBaseUrl, layerUrl } = appConfig;

export const url = (layer: string, EPSGType: string) => {
  return `${geoserverBaseUrl}${layerUrl
    .replace("##TYPENAME##", layer)
    .replace("##EPSGTYPE##", EPSGType)}`;
};
